import React, { memo, useMemo } from "react";

function generateStarPolygon(boxes, playerCount) {
  return boxes
    .map((cord, idx) => ({ cord, position: idx }))
    .filter(({ position }) => position % 18 === 3)
    .map(({ cord, position }, idx) => ({
      points: generateStarPoints(cord, idx, playerCount),
      position,
    }));
}

function generateStarPoints(coordinates, idx, playerCount) {
  const coordsArray = coordinates
    .split(" ")
    .map((coord) => coord.split(",").map(parseFloat));

  const outerRange =
    idx === 0 ||
    idx === playerCount / 2 ||
    idx === playerCount / 2 - 1 ||
    idx === playerCount - 1
      ? 2 * playerCount * 0.16
      : 1;

  const [x1, y1, x2, , x3, y3, , y4] = coordsArray.flat();
  const centerX = (x1 + x3) / 2;
  const centerY = (y1 + y3) / 2;
  const width = Math.abs(x2 - x1);
  const height = Math.abs(y4 - y1);
  const maxRadius = Math.min(width / 2, height / 2);
  const numPoints = 5;
  const innerRadius = maxRadius / 2;
  const outerRadius = maxRadius * outerRange;
  const points = [];

  for (let i = 0; i < numPoints * 2; i++) {
    const angle = (i * Math.PI) / numPoints;
    const radius = i % 2 === 0 ? outerRadius : innerRadius;
    points.push([
      centerX + radius * Math.cos(angle),
      centerY + radius * Math.sin(angle),
    ]);
  }

  return points.map((point) => point.join(",")).join(" ");
}

function LudoStarBoxes({ numberWiseColor, playerCount, boxes = [], gotis = [] }) {
  const stars = useMemo(
    () => generateStarPolygon(boxes, playerCount),
    [boxes, playerCount],
  );

  const occupiedPositions = useMemo(() => {
    const set = new Set();
    gotis.forEach((g) => { if (g.position >= 0 && !g.finished) set.add(g.position); });
    return set;
  }, [gotis]);

  return (
    <>
      {stars?.map(({ points, position }, idx) => {
        const color = numberWiseColor[(idx + 1) % playerCount];
        const occupied = occupiedPositions.has(position);
        return (
          <g key={idx}>
            <polygon points={points} fill={color} stroke={color} strokeWidth="2" />
            {occupied && (
              <polygon
                points={points}
                fill="none"
                stroke="white"
                strokeWidth="3"
                className="starOccupiedGlow"
              />
            )}
          </g>
        );
      })}
    </>
  );
}

export default memo(LudoStarBoxes);
